import React from 'react';

/**
 * Section - Explain Section
 * Explains the Radio & Ich motto and KI/PKI modes
 */
export function ExplainSection({ backgroundColor }) {
  return (
    <div
      id="explain"
      className="min-h-screen flex flex-col items-center justify-center w-full relative px-4 sm:px-8 md:px-16 lg:px-24 py-16 overflow-hidden"
      style={{
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
      }}
    >
      <div className="max-w-6xl w-full">
        {/* Hero Statement */}
        <div className="mb-16 sm:mb-24">
          <p className="text-gray-400 text-sm sm:text-base uppercase tracking-widest mb-4">Unser Konzept</p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-8">
            Ein <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">KI-Radiosender</span>,<br />
            der sich an dich anpasst
          </h2>
          <p className="text-xl sm:text-2xl text-gray-400 max-w-3xl leading-relaxed">
            <span className="text-white">schmalgsicht v2</span> – Stimmen, Moderationen und alle Inhalte werden vollständig automatisiert von der KI erstellt.
          </p>
        </div>

        {/* Asymmetric Mode Layout */}
        <div className="relative md:pb-32">
          {/* KI Mode - Large left block */}
          <div className="md:w-2/3 mb-6 md:mb-0">
            <div className="bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 shadow-2xl">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <span className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-cyan-400">KI</span>
                <div>
                  <p className="text-xs sm:text-sm text-gray-500 uppercase tracking-wider">Modus</p>
                  <h3 className="text-lg sm:text-2xl md:text-3xl font-bold text-gray-900">Einer für alle</h3>
                </div>
              </div>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed md:pr-32 lg:pr-40">
                Im KI-Modus hörst du den <span className="font-semibold text-gray-900">öffentlichen Stream</span> – moderiert von Chris oder Lena mit automatisch recherchierten Nachrichten, Wetter und aktuellen Themen aus dem Web. Die Musik wird passend zur Tageszeit zusammengestellt.
              </p>
            </div>
          </div>

          {/* PKI Mode - Floating right block */}
          <div className="md:absolute md:right-0 md:top-1/2 md:-translate-y-1/2 md:w-1/2">
            <div className="bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 shadow-2xl text-white">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <span className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black">PKI</span>
                <div>
                  <p className="text-xs sm:text-sm text-white/70 uppercase tracking-wider">Modus</p>
                  <h3 className="text-lg sm:text-2xl md:text-3xl font-bold">100% Ich</h3>
                </div>
              </div>
              <p className="text-sm sm:text-base md:text-lg text-white/90 leading-relaxed">
                Im PKI-Modus füllst du das <span className="font-semibold">Freundebuch</span> aus. Die schmalsoft MoodAPI nutzt deine Angaben zu Stimmung, Interessen, Tagesplanung und vielen weiteren Faktoren, um <span className="font-semibold">Themen speziell für dich</span> auszuwählen und aufzubereiten – und deine Wunsch-Genres bestimmen die Musik. So erhältst du genau das Radio, das zu 100% dein Ich widerspiegelt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
